export default "__VITE_ASSET__BWiaovPg__"